import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { App } from 'client/shared/components/app';
import { ClientUrlUtils } from 'client/shared/core/helpers';
import { QuestionEmbedPage } from 'client/embed/pages/question/question-embed-page';
import { SignupPage } from 'client/embed/pages/signup/signup-page';
import { LoginPage } from 'client/embed/pages/login/login-page';
import { VisualizationEmbedPage } from './pages/visualization/visualization-embed-page';
import { GenericContentPage } from './pages/generic-content/generic-content-page';
import { EmbedContext } from 'client/shared/contexts/embed-context';

const UrlUtils = ClientUrlUtils.embed;

export const Embed: React.FC = () => {
  return (
    <App>
      <EmbedContext.Provider value={true}>
        <Route path="/embed">
          <Switch>
            <Route
              component={QuestionEmbedPage}
              exact
              path={UrlUtils.question.path({
                pubSlug: ':pubSlug',
                setIdOrSlug: ':setSlug',
                questionId: ':questionId',
              })}
            />
            <Route component={SignupPage} exact path={UrlUtils.signup.path()} />
            <Route component={LoginPage} exact path={UrlUtils.login.path()} />
            <Route
              component={GenericContentPage}
              exact
              path={UrlUtils.legacyContentPost.path({
                contentPostSlug: ':setSlug',
                pubSlug: ':pubSlug',
              })}
            />
            <Route
              component={GenericContentPage}
              exact
              path={UrlUtils.genericContent.path({
                contentSlug: ':setSlug',
                pubSlug: ':pubSlug',
              })}
            />
            <Route
              component={VisualizationEmbedPage}
              exact
              path={UrlUtils.visualization.path({ visualizationId: ':visId' })}
            />
          </Switch>
        </Route>
      </EmbedContext.Provider>
    </App>
  );
};
